import React from "react";
import {parseBoolean} from "../commonmethod/CommonMethod";
import "./simmsRadio.css";

function SimmsRadio({data, style, options, onChange, title, ...rest}) {
    const handleChange = (v) => {
        onChange(parseBoolean(v));
    };

    return (
        <div
            className="radio-group"
            style={style?.group ?? {}}
            role="radiogroup"
            aria-label={title}
            {...rest}
        >
            <div className="radio-group__options" style={style?.button ?? {}}>
                {options.map((option, index) => {
                    const checked = data == option.value;
                    const inputId = `${title ?? "radio"}-${option.value}-${index}`;

                    return (
                        <label
                            key={option.value ?? index}
                            htmlFor={inputId}
                            className={`radio-group__option${checked ? " is-checked" : ""}`}
                            style={style?.label ?? {}}
                        >
                            <input
                                id={inputId}
                                className="radio-group__input"
                                style={style?.input ?? {}}
                                type="radio"
                                name={title}
                                value={option.value}
                                checked={checked}
                                onChange={(e) => handleChange(e.target.value)}
                            />
                            <span className="radio-group__label">{option.text}</span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}

export {SimmsRadio};
